import customConnect from '../customConnect';
import {wmsLayer, wmsBWLayer, photoLayer, eestiPhotoLayer, topoLayer, 
	vectorLayer, vectorLayerLabels, blankLayer, topo75Layer, lidarLayer} from './mapLayers';
//import {vectorL} from './poiWMS';
import { resolutions } from '../config';
import {map, view as defaultView} from '../map/map';
import View from 'ol/View.js';
import baseLayerVisiblity from './baseLayerVisiblity';

var layerMap = {
	blankLayer: [blankLayer],
	wmsLayer: [wmsLayer],
	wmsBWLayer: [wmsBWLayer],
	photoLayer: [ photoLayer ],
	topoLayer: [topoLayer],
	topo75Layer: [topo75Layer],
	lidarLayer: [lidarLayer]
//	vectorLayer: [vectorLayer, vectorLayerLabels]
};

const MAX_X = 3164430;
const MIN_X = 2322462;
const MAX_Y = 8338310;
const MIN_Y = 7493274;

const constrainedView = new View({
//	center: default_coords,
//	zoom: default_zoom,
	maxZoom: 18,
	minZoom: 8, //11 / 6
	projection: 'EPSG:3857',
	resolutions: resolutions,
	extent: [ MIN_X, MIN_Y, MAX_X, MAX_Y ]
});



const setExtent = (layerName) => {

	var currentView = map.getView();

	switch(layerName) {

		case 'topoLayer':
		case 'topo75Layer':

			var centerCoords = currentView.getCenter();

			if(centerCoords[0] < MIN_X) {
				centerCoords[0] = MIN_X;
			}

			if(centerCoords[0] > MAX_X) {
				centerCoords[0] = MAX_X;
			}

			if(centerCoords[1] < MIN_Y) {
				centerCoords[1] = MIN_Y;
			}

			if(centerCoords[1] > MAX_Y) {
				centerCoords[1] = MAX_Y;
			}

			constrainedView.setCenter(centerCoords);
			constrainedView.setZoom(currentView.getZoom());
			map.setView(constrainedView);
		break;
		default:
			defaultView.setCenter(currentView.getCenter());
			defaultView.setZoom(currentView.getZoom());
			map.setView(defaultView);
	}

	return;
}

const toggleLayers = (newBaseLayer, layers) => {
	var existingLayers = map.getLayers().getArray();



	layers.map(layerName => {

		if(newBaseLayer == layerName) {
			setExtent(layerName);
		}


		if (newBaseLayer == layerName && existingLayers.indexOf(layerMap[layerName]) === -1) {

			if(typeof layerMap[layerName] !== 'undefined') {

				layerMap[layerName].map((layer) => {
					if(map.getLayers().getArray().indexOf(layer) === -1) {
						map.addLayer(layer);

					}
				});


			}
		} else {

			if(typeof layerMap[layerName] !== 'undefined') {

				layerMap[layerName].map((layer) => {
					if(map.getLayers().getArray().indexOf(layer) !== -1) {
						map.removeLayer(layer);
					}
				});

			}
		}
	});
}

var stateUpdateHandler = function({ activeLayer, layers, poiLayer }) {

	//Special case POI enabled and Tradicional map enabled. Hide Tradicional layer wms
	if(activeLayer === 'wmsLayer' && poiLayer) {

		layerMap[activeLayer].map((layer) => {

			if(map.getLayers().getArray().indexOf(layer) !== -1) {
				map.removeLayer(layer);
			}

		});

	} else {

		toggleLayers(activeLayer, layers);
	}

};

export default function (store) { //new props and action function

	baseLayerVisiblity({store, map});

	const mapStateToPropsRes = (state) => {

		return {
			activeLayer: state.baseLayers.active,
			layers: state.baseLayers.layers,
		//	poiLayer: state.dataLayers.poiLayer
		};
	};

	const mapDispatchToPropsRes = (dispatch) => {

	  return {};
	};

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}
